<div class="py-2">

  <!-- Loading spinner -->
  <div *ngIf="loading" class="flex justify-center items-center py-8">
    <svg class="nf-spinner" viewBox="0 0 50 50">
      <circle class="nf-spinner__track" cx="25" cy="25" r="20"></circle>
      <circle class="nf-spinner__arc" cx="25" cy="25" r="20"></circle>
    </svg>
  </div>

  <!-- Error state -->
  <div *ngIf="!loading && loadError"
    class="flex justify-center items-center py-8 text-sm text-[#ef4444]">
    Failed to load related documents. Please try again.
  </div>

  <!-- Empty state -->
  <div *ngIf="!loading && !loadError && documents.length === 0"
    class="flex justify-center items-center py-8 text-sm text-[#64758B]">
    {{ emptyMessage }}
  </div>

  <!-- Documents table -->
  <p-table *ngIf="!loading && !loadError && documents.length > 0"
    [value]="documents"
    styleClass="w-full"
    [tableStyle]="{ 'width': '100%' }"
    size="small"
    [rowHover]="true">
    <ng-template #header>
      <tr>
        <th class="text-xs font-medium text-[#374151] py-3 px-4">Document Type</th>
        <th class="text-xs font-medium text-[#374151] py-3 px-4">Document Number</th>
        <th class="text-xs font-medium text-[#374151] py-3 px-4">Posting Date</th>
        <th class="text-xs font-medium text-[#374151] py-3 px-4">Document Date</th>
        <th class="text-xs font-medium text-[#374151] py-3 px-4">Subsidiary</th>
        <th class="text-xs font-medium text-[#374151] py-3 px-4">Location</th>
      </tr>
    </ng-template>
    <ng-template #body let-doc let-rowIndex="rowIndex">
      <tr
        class="text-sm"
        [ngClass]="{
          'cursor-pointer': isNavigable(doc),
          'bg-[#f2f5ff]': rowIndex % 2 === 0
        }"
        (click)="navigateTo(doc)">
        <td class="py-3.5 px-4">
          <span class="px-2 py-1 rounded text-xs font-medium"
            [ngClass]="badgeClasses[doc.document_type] || 'bg-gray-100 text-gray-700'">
            {{ doc.document_type }}
          </span>
        </td>
        <td class="py-3.5 px-4"
          [ngClass]="{ 'text-[#4A6DFB] underline underline-offset-2': isNavigable(doc) }">
          {{ doc.document_number || '-' }}
        </td>
        <td class="py-3.5 px-4">{{ (doc.posting_date | date:'dd/MM/yyyy') || '-' }}</td>
        <td class="py-3.5 px-4">{{ (doc.document_date | date:'dd/MM/yyyy') || '-' }}</td>
        <td class="py-3.5 px-4">{{ doc.subsidiary_name || '-' }}</td>
        <td class="py-3.5 px-4">{{ doc.location_name || '-' }}</td>
      </tr>
    </ng-template>
  </p-table>

</div>
